// extracted by mini-css-extract-plugin
module.exports = {"story":"Museum_story__2FMlv","intro":"Museum_intro__3rVYQ"};